module.exports = __webpack_public_path__ + "static/media/Sudipt.aed58289.jpg";